import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export const ProductBannerContainer = styled.div`
  padding: 20px 0px 30px 0px;
`;

export const Headline = styled.h2`
  text-align: left;
  margin-bottom: 8px;
`;

export const BodyText = styled.p`
  text-align: left;
`;

export const HeadingContainer = styled.div`
  margin-bottom: 48px;
`;

export const BoxRow = styled.div`
  display: flex;
  gap: 32px;
  padding-top: 30px;

  @media (max-width: 768px) {
    align-items: stretch;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scroll-padding: 0 12%;
    gap: 8px;
    width: 100%;
    padding-top: 50px;
    padding-bottom: 12px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

/*   @media (min-width: 700px) and (max-width: 1160px) {
    width: 100%;
    padding: 0px 4px;
  } */
`;

export const Box = styled.div<{ offer: boolean }>`
  flex: 0 0 calc((100% - 16px) / 3);
  border-radius: 24px;
  background: #fff;
  text-align: left;
  box-shadow: rgba(0, 0, 0, 0.12) 2px 1px 8px 4px;
  transition: transform 0.4s ease-in-out;
  display: flex;
  border: ${({ offer }) => (offer ? "1px solid var(--color-orange)" : "1px solid var(--color-blue-50)")};
  margin-top: ${({ offer }) => (offer ? "-30px" : "0px")};

  &:hover {
    transform: translateY(-8px);
  }

  @media (max-width: 700px) {
    flex: 0 0 76%;
    scroll-snap-align: center;

    &:hover {
      transform: none;
    }

  }

  @media (max-width: 428px) {
    flex: 0 0 84%;
  }

  @media (min-width: 700px) and (max-width: 1160px) {
    flex: 0 0 calc((100% - 33px) / 3);
  }
`;

export const BoxContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentLabel = styled.div`
  color: #fff;
  background-color: var(--color-orange);
  width: max-content;
  padding: 6px 24px;
  margin-top: -39px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
  clip-path: polygon(
    0% 0%,
    100% 0%,
    calc(100% - 12px) 50%,
    100% 100%,
    0% 100%,
    12px 50%
  );
  p {
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 0;
  }
`;

export const ContentHeadline = styled.div`
  font-size: 20px;
  color: var(--color-coal);
  margin-bottom: 10px;
  font-weight: 600;
`;

export const ContentSubtext = styled.p`
  font-size: 12px;
  margin-bottom: 8px;
`;

export const PriceContainer = styled.div`
    margin-bottom: 6px;
`;

export const Price = styled.div<{ offer: boolean }>`
  font-size: 32px;
  color: ${({ offer }) => (offer ? "var(--color-orange)" : "var(--color-blue-700)")};
  font-weight: 600;
  word-spacing: -4px;
`;

export const Valuta = styled.span`
  font-size: 12px;
  color: var(--color-coal);
  font-weight: 600;
`;

export const FeatureList = styled.ul`
    padding: 8px 0px 16px 0px;
`;

export const Feature = styled.li`
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
`;

export const FeatureListIcon = styled.div<{ offer: boolean }>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
  background-color: ${({ offer }) => (offer ? "var(--color-orange)" : "var(--color-blue-50)")};
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1px;
`;

export const CheckMark = styled(FaCheck)<{ offer: boolean }>`
    color: ${({ offer }) => (offer ? "#fff" : "var(--color-blue-700)")};
    width: 8px;
`;

export const FeatureText = styled.div`
    font-size: 12px;
    color: #707070;
`;

export const CustomButton = styled.a<{ offer: boolean }>`
  padding: 12px;
  width: 100%;
  font-size: 14px;
  margin-top: auto;
  display: block;
  text-align: center;
  text-decoration: none;
  border-radius: 35px;
  color: var(--color-white);
  background-color: ${({ offer }) => (offer ? "var(--color-orange)" : "var(--color-blue-700)")};
`;

export const SmallText = styled.span`
  display: block;
  text-align: center;
  font-size: 12px;
  color: #707070;
  margin-top: 8px;
  cursive: italic;
`;

export const ProgressBar = styled.div`
  display: none;

  @media (max-width: 700px) {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
  }
`;

export const ProgressStep = styled.div<{ $active?: boolean }>`
  border-radius: 50%;
  background: ${({ $active }) => ($active ? "var(--color-orange)" : "#e0e0e0")};
  width: 14px;
  height: 14px;
  margin: 0 3px;
  transition: all 0.2s ease-in-out;
`;

export const ContactMeContainer = styled.div`
    position: fixed;
    z-index: 5000;
    left: 0;
    top: 0;
    width: 100%;
    min-height: -webkit-fill-available;
    overflow: auto;
    background-color: #006571;
    max-height: 100vh !important;
    overflow-y: scroll;
    p {
    margin-bottom: 0px;
    }
`;

export const ContactMeContent = styled.div`
    width: 90%;
    text-align: center;
    color: #ffffff;
    margin-left: auto; 
    margin-right: auto;
    @media (min-width: 1024px) { 
        width: 40%;
    }
`;

export const ContactMeHeadline = styled.h1`
    padding-top: 40px;
`;

export const ContactMeSubtitle = styled.p`
    font-size: 16px;
    margin-top: 18px;
`;

export const ContactMeChosenProduct = styled.p`
    font-size: 14px;
    margin-top: 18px;
`;

export const CloseButton = styled.button`
    display: flex;
    float: right;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #ffffff;
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: right;
    margin: 24px 24px 0px 0;
`;

export const ModalInputContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ModalInput = styled.input`
    padding: 20px 16px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid var(--color-grey-100);
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);
    &:focus-visible {
        outline: 2px solid var(--color-coal);
    }
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
`;